import { isAndroid, isIOS, osVersion } from 'mobile-device-detect';
import IRenderer from './System/Render/IRenderer';
import PIXIRenderer from './System/Render/PIXIRenderer';
import Environment from './Utility/Environment';
import IResourceDriver from './Utility/Resource/IResourceDriver';
import PIXIResource from './Utility/Resource/PIXIResource';
import ISDKDriver from './Utility/SDK/ISDKDriver';
import SDKWEBDriver from './Utility/SDK/SDKWEBDriver';

export type GameConfig = {
    version: string;
    language: string;
    resourceDriver: { new (): IResourceDriver };
    renderer: { new (): IRenderer };
    SDKDriver: { new (): ISDKDriver };
    fpsLimit: number;
    dataSaveIntervalMS: number;
    GBConnectionRetryIntervalMS: number;
    forceCanvas: boolean;
    // adInterstitialID: string;
    // adRewardedID: string;
    // DDNA_URL: string;
    // DDNA_KEY: string;
    // DDNA_EventSendInterval: number;
    // gameID: string;
    levelBasePath: string;
    trackingEnabled: boolean;
};

declare const __VERSION__: string;

export async function getGameConfig() {
    return {
        version: __VERSION__,
        language: 'en',
        resourceDriver: PIXIResource,
        renderer: PIXIRenderer,
        SDKDriver: SDKWEBDriver,
        fpsLimit: 60,
        dataSaveIntervalMS: 10000,
        GBConnectionRetryIntervalMS: 5000,
        DDNA_EventSendInterval: 15000,
        forceCanvas: false,
        levelBasePath: 'resource/data/levels',
        trackingEnabled: false,
    };
}
